// extracted by mini-css-extract-plugin
export var buttonContainer = "_7g-1";
export var fontSizeSelect = "_7g-3";
export var formatSelect = "_7g-2";
export var formats = "_7g-4";
export var hidden = "_7g-5";
export var icon = "_7g-6";
export var select = "_7g-0";